import { render, staticRenderFns } from "./StudentFilter.vue?vue&type=template&id=041c2e31&scoped=true"
import script from "./StudentFilter.vue?vue&type=script&lang=js"
export * from "./StudentFilter.vue?vue&type=script&lang=js"
import style0 from "./StudentFilter.vue?vue&type=style&index=0&id=041c2e31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041c2e31",
  null
  
)

export default component.exports